// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.combobox {
    display: inline-flex;
    align-items: center;
    user-select: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    border: 1px solid var(--border-color);
    background-color: var(--list-bg-color);
    height: 2em;
}

div.combobox-button {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
    height: 100%;
    position: relative;
}

span.combobox-button-content {
    padding: 0 0.25em;
    flex: 1 1 auto;
    white-space: nowrap;
    line-height: 2em;
}

input.combobox-button-filter {
    position: absolute;
    z-index: 1;
    border: none!important;
    background-color: transparent!important;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}

div.combobox-button > span.icon {
    font-size: 100%;
    flex: 0 0 1em;
}

div.combobox-menu {
    border: 1px solid var(--border-color);
    background-color: var(--list-bg-color);
    user-select: none;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
}

div.combobox-menu-entry {
    padding: 0.25em;
}

div.combobox-menu-entry:not(.combobox-menu-entry-disabled):hover  {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

div.combobox-menu-entry-active {
    background-color: var(--list-item-bg-color-active);
    color: var(--list-item-text-color-active);
}

div.combobox-menu-entry-active:hover {
    background-color: var(--list-item-bg-color-active-hover)!important;
    color: var(--list-item-text-color-active-hover)!important;
}

div.combobox-menu-entry-disabled {
    color: var(--text-color-disabled);
}

div.combobox-menu-entry-group-header {
    display: flex;
    background-color: var(--list-section-bg-color);
    color: var(--list-section-text-color);
    font-weight: bold;
}

div.combobox-menu-entry-group-header > span.icon {
    flex: 0 0 auto;
}`, "",{"version":3,"sources":["webpack://./qwc2/components/widgets/style/ComboBox.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;IACzB,qCAAqC;IACrC,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,uCAAuC;IACvC,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;AACb;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,kEAAkE;IAClE,yDAAyD;AAC7D;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,8CAA8C;IAC9C,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["div.combobox {\n    display: inline-flex;\n    align-items: center;\n    user-select: none;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    border: 1px solid var(--border-color);\n    background-color: var(--list-bg-color);\n    height: 2em;\n}\n\ndiv.combobox-button {\n    flex: 1 1 auto;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    position: relative;\n}\n\nspan.combobox-button-content {\n    padding: 0 0.25em;\n    flex: 1 1 auto;\n    white-space: nowrap;\n    line-height: 2em;\n}\n\ninput.combobox-button-filter {\n    position: absolute;\n    z-index: 1;\n    border: none!important;\n    background-color: transparent!important;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n}\n\ndiv.combobox-button > span.icon {\n    font-size: 100%;\n    flex: 0 0 1em;\n}\n\ndiv.combobox-menu {\n    border: 1px solid var(--border-color);\n    background-color: var(--list-bg-color);\n    user-select: none;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n}\n\ndiv.combobox-menu-entry {\n    padding: 0.25em;\n}\n\ndiv.combobox-menu-entry:not(.combobox-menu-entry-disabled):hover  {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n}\n\ndiv.combobox-menu-entry-active {\n    background-color: var(--list-item-bg-color-active);\n    color: var(--list-item-text-color-active);\n}\n\ndiv.combobox-menu-entry-active:hover {\n    background-color: var(--list-item-bg-color-active-hover)!important;\n    color: var(--list-item-text-color-active-hover)!important;\n}\n\ndiv.combobox-menu-entry-disabled {\n    color: var(--text-color-disabled);\n}\n\ndiv.combobox-menu-entry-group-header {\n    display: flex;\n    background-color: var(--list-section-bg-color);\n    color: var(--list-section-text-color);\n    font-weight: bold;\n}\n\ndiv.combobox-menu-entry-group-header > span.icon {\n    flex: 0 0 auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
